import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminSignInMutation } from 'api';
import { Form, FormProps, notification } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { ErrorMappingValueType } from 'typings';
import { AdminSignInFieldType } from 'typings/auth';

export const useAdminSignIn = () => {
  const [signIn, { isLoading }] = useAdminSignInMutation();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({
        message: message,
      });
    },
    [notificationApi]
  );

  const onFinish: FormProps<AdminSignInFieldType>['onFinish'] = useCallback(
    (values: AdminSignInFieldType) => {
      signIn(values)
        .then(({ data, error }: any) => {
          if (data?.success) {
            navigate(`${ADMIN_ROUTES.dashboardPage}/${ADMIN_ROUTES.dashboardList}`);
          } else {
            if (data) {
              Object.keys(data).forEach((_key: string) => {
                if (_key === 'response_code') {
                  openNotificationWithIcon({ type: 'error', message: 'Email or password is invalid!' });
                } else {
                  _key &&
                    openNotificationWithIcon({
                      type: 'error',
                      message: data[_key],
                    });
                }
              });
            } else if (error?.data) {
              openNotificationWithIcon({
                type: 'error',
                message: 'Something went wrong!',
              });
            }
          }
        })
        .catch((err) => {
          console.log(err, 'error');
        });
    },

    [signIn, openNotificationWithIcon, navigate]
  );

  return {
    onFinish,
    isLoading,
    contextHolder,
    form,
  };
};
